export class AdjustmentFilterEntity {
  validFrom?: string
  validTo?: string
  driverName?: string
  searchWord?: string
  page?: number
  limit?: number
}
